import { lazy, Suspense } from "react";
import "./style/style.css";
import { StyledEngineProvider } from "@mui/material/styles";
const Loading = lazy(() => import("./Components/LoadingSpinner/index"));
const PublicRoute = lazy(() => delayForLoading(import("./Routes/index")));
function App() {
  return (
    <StyledEngineProvider injectFirst>
      <Suspense fallback={<Loading animation="grow" variant="dark" />}>
        <PublicRoute />
      </Suspense>
    </StyledEngineProvider>
  );
}
const delayForLoading = async (promise) => {
  await new Promise((resolve) => {
    setTimeout(resolve, 2000);
  });
  return promise;
};
export default App;
